import { render, staticRenderFns } from "./VAppSidebarNavigation.vue?vue&type=template&id=d4dbd8b2&"
import script from "./VAppSidebarNavigation.vue?vue&type=script&lang=ts&"
export * from "./VAppSidebarNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./VAppSidebarNavigation.vue?vue&type=style&index=0&id=d4dbd8b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports